module.exports = __webpack_public_path__ + "static/media/goatgroup.7ce3ad02.gif";